import { toast } from "sonner";
import { NotifyCard, notifyBtn } from "./NotifyCard";

// Render every toast.success/error/warning/info as the shared NotifyCard (with OK button).
const DURATION = { success: 4000, info: 4000, warning: 6000, error: 7000 };
const toText = (v) => (typeof v === "function" ? v() : v);

if (!toast.__notifyPatched) {
  ["success", "error", "warning", "info"].forEach((type) => {
    toast[type] = (message, opts = {}) => {
      const { description, ...rest } = opts || {};
      return toast.custom((id) => (
        <NotifyCard type={type} message={toText(message)} testid={`toast-${type}`}
          actions={<button data-testid={`toast-${type}-ok`} onClick={() => toast.dismiss(id)} className={notifyBtn.ok}>OK</button>}>
          {description && <div className="mt-1 text-[13px] text-slate-400 whitespace-pre-line break-words">{toText(description)}</div>}
        </NotifyCard>
      ), { duration: DURATION[type], ...rest, unstyled: true });
    };
  });
  toast.__notifyPatched = true;
}
